import { render, staticRenderFns } from "./YourPlanColumn.vue?vue&type=template&id=706011c7&scoped=true&lang=pug&"
import script from "./YourPlanColumn.vue?vue&type=script&lang=js&"
export * from "./YourPlanColumn.vue?vue&type=script&lang=js&"
import style0 from "./YourPlanColumn.vue?vue&type=style&index=0&id=706011c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706011c7",
  null
  
)

export default component.exports